import { createSystem, defaultConfig, defineConfig, defineRecipe } from '@chakra-ui/react'
import { alertSlotRecipe } from './alertSlotRecipe'
import { buttonRecipe } from './buttonRecipe'
import { checkboxSlotRecipe } from './checkboxSlotRecipe'
import { formSlotRecipe } from './formSlotRecipe'
import { inputRecipe } from './inputRecipe'
import { inputAddonRecipe } from './inputAddonRecipe'
import { popoverSlotRecipe } from './popoverSlotRecipe'
import { radioSlotRecipe } from './radioSlotRecipe'
import { selectSlotRecipe } from './selectSlotRecipe'
import { tableRecipe } from './tableRecipe'
import { tooltipSlotRecipe } from './toolTipRecipe'
import { customColors } from './colors'
import { modalSlotRecipe } from './modalSlotRecipe'
import { radioGroupSlotRecipe } from './radioGroupSlotRecipe'
import { toastSlotRecipe } from './toastRecipe'

const borderRadius = {
  none: { value: '0' },
  sm: { value: '0.1875rem' },
  base: { value: '0.25rem' },
  md: { value: '0.375rem' },
  lg: { value: '0.5rem' },
  xl: { value: '0.75rem' },
  '2xl': { value: '1rem' },
  '3xl': { value: '1.5rem' },
  full: { value: '9999px' },
}

const config = defineConfig({
  globalCss: {
    'html, body': {
      color: customColors.brand.blue.value,
      fontWeight: 300,
    },
  },
  theme: {
    tokens: {
      colors: customColors,
      fonts: {
        body: { value: 'Roboto' },
        heading: { value: 'Roboto' },
      },
      radii: borderRadius,
    },
    textStyles: {
      base: {
        fontWeight: 200,
        fontSize: '16px',
      },
      formHeader: {
        value: {
          fontWeight: 500,
          lineHeight: '187%',
          fontSize: '1.275rem',
        },
      },
      formSubHeader: {
        value: {
          fontWeight: 500,
          lineHeight: '187%',
          fontSize: '1.125rem',
        },
      },
      warning: {
        value: {
          fontStyle: 'italic',
          fontSize: '1.2rem',
          fontWeight: 300,
          lineHeight: '140%',
          marginBlock: '2rem',
        },
      },
      widget: {
        value: {
          fontSize: '1.5rem',
          fontWeight: 300,
          lineHeight: '140%',
          marginBlock: '2rem',
        },
      },
      widgetSmall: {
        value: {
          fontSize: '1rem',
          fontWeight: 300,
          lineHeight: '120%',
          marginBlock: '2rem',
        },
      },
    },
    slotRecipes: {
      alert: alertSlotRecipe,
      checkbox: checkboxSlotRecipe,
      popover: popoverSlotRecipe,
      select: selectSlotRecipe,
      radio: radioSlotRecipe,
      form: formSlotRecipe,
      modal: modalSlotRecipe,
      radioGroup: radioGroupSlotRecipe,
      tooltip: tooltipSlotRecipe,
      toast: toastSlotRecipe,
    },
    recipes: {
      button: buttonRecipe,
      table: tableRecipe,
      input: inputRecipe,
      inputAddon: inputAddonRecipe,
      heading: defineRecipe({
        base: {
          fontWeight: 500,
        },
        variants: {
          variant: {
            widget: {
              fontSize: '2.125rem',
              fontWeight: 500,
              lineHeight: '140%',
              textWrap: 'balance',
            },
            widgetSmall: {
              fontSize: '1.75rem',
              fontWeight: 500,
              lineHeight: '140%',
              textWrap: 'balance',
            },
          },
        },
      }),
      link: defineRecipe({
        base: {
          color: 'red.400',
          textDecoration: 'underline',
        },
        defaultVariants: {
          variant: 'underline',
        },
        variants: {
          variant: {
            plain: {
              color: 'brand.blue',
            },
            underline: {
              color: 'brand.blue',
            },
            bankid: { color: 'white' },
            widget: {
              fontSize: '1.25rem',
              fontWeight: 400,
              lineHeight: '168%',
            },
          },
        },
      }),
      textarea: {
        variants: {
          variant: {
            outline: {
              background: 'white',
              borderColor: 'brand.blue',
              borderRadius: 'sm',
              _focus: { borderColor: '#3182ce', boxShadow: '#3182ce 0px 0px 0px 1px' },
            },
          },
        },
      },
      formError: {
        base: {
          justifyContent: 'flex-start',
          color: 'facebook',
        },
      },
    },
  },
})

export default createSystem(defaultConfig, config)
